exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".SubMenu-local__back_office--2QeME {\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n  display: -ms-flexbox;\n  display: flex;\n  border-radius: 5px;\n  padding: 2px 3px 3px 2px;\n  cursor: pointer;\n  margin-right: 15px;\n  width: 135px;\n  height: 31px; }\n  .SubMenu-local__back_office--2QeME span {\n    color: #28394d;\n    margin-left: 5px; }\n", ""]);

// exports
exports.locals = {
	"back_office": "SubMenu-local__back_office--2QeME"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"localIdentName":"[name]__[local]--[hash:base64:5]","importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["/home/runner/work/data/data/src","node_modules/foundation-sites/scss","node_modules/motion-ui/src"]}!./src/components/Menu/SubMenu/SubMenu.local.scss
// module id = 2894
// module chunks = 0